export default __webpack_public_path__ + "static/media/board-games.341764a0.png";